import { apiService } from './index';

// Inport types
import { Template } from '../shared/types/template';

export const asyncGetTemplateByCode = async (
    code: string
): Promise<Template | undefined> => {
    try {
        const { items }: any = await apiService.get(
            `/api/template/by-code/${code}`
        );
        return items;
    } catch (error) {}
};

export const asyncGetTemplates = async (): Promise<Template[]> => {
    try {
        const { items }: any = await apiService.get(`/api/template`);

        return items;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const asyncUpdateTemplate = async (template: Template | any) => {
    try {
        if (!template.id) {
            const data: Template = {
                ...template,
                id: '',
            };
            const { items }: any = await apiService.post(`/api/template`, data);
            return items;
        }
        const { items }: any = await apiService.patch(
            `/api/template/${template.id}`,
            template
        );
        return items;
    } catch (error) {
        console.error(error);
        return;
    }
};
